import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [openSection, setOpenSection] = useState(null);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="product-detail">
      <Header />

      <main className="product-detail__container">
        <div className="gallery-column">
          <div className="main-image">
            {product.images.map((img, index) => (
              <img key={index} src={img} alt={product.name} />
            ))}
          </div>
        </div>

        <aside className="product-info">
          <div className="product-reviews">
            <span className="stars">★★★★★</span>{" "}
            <span className="count">{product.reviews} Reviews</span>
          </div>

          <div className="product-name">
            {product.name}, {product.material}, {selectedColor}
          </div>
          <div className="product-price">
            €{Number(product.price).toLocaleString("en-US")}
          </div>

          <div className="product-description">
            {product.description?.map((line, i) => (
              <p key={i}>{line}</p>
            ))}
          </div>

          <div className="product-options">
            <div className="label">Select Color</div>
            <div className="sizes">
              {product.colors?.map((s) => (
                <button
                  key={s}
                  className={`size-btn ${
                    selectedColor === s ? "selected" : ""
                  }`}
                  onClick={() => setSelectedColor(s)}
                >
                  {s}
                </button>
              ))}
            </div>

            <div className="label">Select Size</div>
            <div className="sizes">
              {product.size?.map((s) => (
                <button
                  key={s}
                  className={`size-btn ${selectedSize === s ? "selected" : ""}`}
                  onClick={() => setSelectedSize(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <div className="product-actions">
            <button className="add-to-cart" onClick={handleAddToCart}>
              ADD TO CART
            </button>
          </div>

          <div className="details-care">
            {[
              {
                key: "compare",
                title: "FEATURES",
                content: product.Features || [],
              },

              {
                key: "shipping",
                title: "SHIPPING & RETURNS",
                content: [
                  "Ships in 1–3 business days.",
                  "Returns accepted within 14 days on unworn items.",
                  "See Shipping & Returns for details.",
                ],
              },
            ].map((sec) => (
              <div className="accordion" key={sec.key}>
                <button
                  className="accordion__header"
                  onClick={() =>
                    setOpenSection(openSection === sec.key ? null : sec.key)
                  }
                >
                  <span>{sec.title}</span>
                  <span className="plus">+</span>
                </button>
                {openSection === sec.key && (
                  <div className="accordion__body">
                    <ul>
                      {sec.content.map((li, i) => (
                        <li key={i}>{li}</li>
                      ))}
                    </ul>
                    {sec.key === "shipping" && (
                      <p>
                        <Link to="/returns" onClick={toTop} className="link">
                          View Shipping & Returns
                        </Link>
                      </p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        </aside>
      </main>

      <Footer />
    </div>
  );
};

export default ProductDetail;
